var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-link',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.skipUrl(_vm.row)}}},[_vm._v(_vm._s(_vm.calcCount))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }